import axios from "axios";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { MdOutlineNavigateNext } from "react-icons/md";
import { GrPrevious } from "react-icons/gr";
import frame from "../images/thumbnail.svg";
import frame1 from "../images/play.svg";
import { RxCross2 } from "react-icons/rx";
import { server_API } from "../config";
import SwipeFeedback from "./SwipeFeedback";
import {
  IoMdArrowBack,
  IoIosArrowUp,
  IoIosArrowDown,
  IoMdInformationCircle,
} from "react-icons/io";
import { IoInformationCircle } from "react-icons/io5";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import { FaStar } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import "swiper/swiper-bundle.css";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
import arrow from "../images/arrow.png";
import ReactApexChart from "react-apexcharts";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip as ChartTooltip,
  Legend as ChartLegend,
} from "chart.js";
import { Radar } from "react-chartjs-2";
// Import Swiper styles
import "swiper/css";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import Copyright from "./Copyright";
import { useSelector } from "react-redux";
import { selectCid } from "../features/companyid";
import { selectUuid } from "../features/userid";
import { documents } from "./DummData";
import Select from "react-select";
import emptydocs from "../images/empty_docs.png";
import { TfiReload } from "react-icons/tfi";
import Tooltip from "./ui/Tooltip";
import axiosInstance from "../axiosInstance";
import { getCurrencySymbol, getPhoneCode, formatSalary } from "../utils/currencyUtils";

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  ChartTooltip,
  ChartLegend
);

const TestAboutCandidate = () => {
  const location = useLocation();
  const { uuid, rank } = location.state;
  const navigate = useNavigate();

  const [applicant, setApplicant] = useState({});
  const [loader, setLoader] = useState(true);
  const [interviews, setInterviews] = useState([]);
  const [url, setUrl] = useState("");
  const [activeQuestion, setActiveQuestion] = useState("");
  const [activeIndex, setActiveIndex] = useState(null);
  const [openPlayer, setOpenPlayer] = useState(false);
  const [openSummary, setOpenSummary] = useState(false);
  const [selectedRows, setSelectdRows] = useState([]);
  const [isRecordedVisible, setRecordedVisible] = useState(true);
  const [isAIVisible, setAIVisible] = useState(true);
  const [expandedSection, setExpandedSection] = useState(null);
  const [isFeedbackVisible, setFeedbackVisible] = useState(false);
  const [isDocumentVisible, setDocumentVisible] = useState(false);
  const [isFromACFL, setIsFromACFL] = useState(false);
  const [jobDetails, setJobDetails] = useState({});
  const [jobid, setJobid] = useState();
  const [skillArray, setSkillArray] = useState([]);
  const [open, setOpen] = useState(false);
  const [maxSalary, setMaxSalary] = useState(0);
  const [minSalary, setMinSalary] = useState(0);
  const [applicantsAdded, setApplicantsAdded] = useState(0);
  const [documentAction, setDocumentAction] = useState("");
  const [viewDocuments, setViewDocuments] = useState(false);
  const companyID = useSelector(selectCid);
  const applicantId = useSelector(selectUuid);
  const [companyCountryCode, setCompanyCountryCode] = useState("IN"); // Default

  const underReviewActions = [
    { label: "Show Document", value: "show" },
    { label: "Download", value: "download" },
  ];

  const rejectedActions = [{ label: "Request", value: "request" }];

  useEffect(() => {
    if (documentAction.length > 0) {
    }
  }, [documentAction]);

  useEffect(() => {
    axiosInstance
      .get(`${server_API}/v2/company/get/${companyID}`)
      .then((res) => {
        setIsFromACFL(res.data.from_acfl);
        if (
          res.data.company_countries &&
          res.data.company_countries.length > 0
        ) {
          setCompanyCountryCode(res.data.company_countries[0]);
        }
      })
      .catch((err) => {
        console.log("company data", err);
        console.log(err);
      });
  }, [companyID]);

  const toggleRecorded = () => {
    setRecordedVisible((prev) => !prev);
  };
  const toggleAi = () => {
    setAIVisible((prev) => !prev);
  };
  const toggleFeedback = () => {
    setFeedbackVisible((prev) => !prev);
  };
  const toggleDocument = () => {
    setDocumentVisible((prev) => !prev);
  };
  // const companyID = localStorage.getItem("companyID");
  // const applicantId = localStorage.getItem("uuid");

  useEffect(() => {
    axios
      .get(`${server_API}/v2/applicant/get/${uuid}/${companyID}`)
      .then((res) => {
        setApplicant(res.data);
        setJobid(res.data.jobid);
        setSkillArray(res.data.skillset.split(","));
        console.log(res.data);
        axios
          .get(`${server_API}/v2/interview/applicant/${uuid}/${companyID}`)
          .then((response) => {
            console.log(response);
            let inter = response.data;

            inter = inter.sort((a, b) => {
              let d1 = new Date(b.taken_on);
              let d2 = new Date(a.taken_on);
              return d1.getTime() - d2.getTime();
            });

            console.log(inter);

            setInterviews(inter);
            setLoader(false);
          })
          .catch((err) => {
            setInterviews([]);
            setLoader(false);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const showResume = () => {
    axios
      .get(`${server_API}/v2/interview/geturl/${companyID}/${applicant.uuid}`)
      .then((response) => {
        window.open(response.data.url, "_blank");
      });
  };

  useEffect(() => {
    if (activeIndex != null) {
      setActiveQuestion(interviews[0].chunk[activeIndex].QuestionText);
      axios
        .get(
          `${server_API}/v2/interview/video/${companyID}/${interviews[0].chunk[activeIndex].Path}`,
        )
        .then((response) => {
          console.log(response);
          setUrl(response.data.url);
          // setOpenPlayer(true);
          // console.log("openplayer",openPlayer)
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [activeIndex]);

  useEffect(() => {
    if (jobid?.length > 0) {
      axios
        .get(`${server_API}/v2/job/get/${jobid}/${companyID}`)
        .then((res) => {
          setJobDetails(res.data);
          console.log(res.data);
          let maxSal = res.data.salaryto;
          let minSal = res.data.salaryfrom;
          maxSal = maxSal.replaceAll(",", "");
          minSal = minSal.replaceAll(",", "");
          setMaxSalary(parseInt(maxSal));
          setMinSalary(parseInt(minSal));
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [applicant]);

  const options = {
    chart: {
      type: "radialBar",
    },
    grid: {
      top: 20,
    },
    series: [67],
    colors: ["rgba(0, 111, 214, 1)"],
    plotOptions: {
      radialBar: {
        startAngle: -90,
        endAngle: 90,
        track: {
          background: "rgba(231, 244, 255, 1)",
          startAngle: -90,
          endAngle: 90,
          strokeWidth: "100%",
        },

        dataLabels: {
          name: {
            show: false,
          },
          value: {
            fontSize: "30px",
            show: false,
          },
        },
        hollow: {
          size: "42%",
        },
      },
    },

    stroke: {
      lineCap: "round",
    },
    labels: ["Progress"],
  };
  const series = [
    {
      name: "Score",
      data: [
        interviews?.[0]?.chunk?.[0]?.BiLSTMScore ?? interviews?.[0]?.chunk?.[0]?.MLNumericScore ?? null,
        interviews?.[0]?.chunk?.[1]?.BiLSTMScore ?? interviews?.[0]?.chunk?.[1]?.MLNumericScore ?? null,
        interviews?.[0]?.chunk?.[2]?.BiLSTMScore ?? interviews?.[0]?.chunk?.[2]?.MLNumericScore ?? null,
        interviews?.[0]?.chunk?.[3]?.BiLSTMScore ?? interviews?.[0]?.chunk?.[3]?.MLNumericScore ?? null,
        interviews?.[0]?.chunk?.[4]?.BiLSTMScore ?? interviews?.[0]?.chunk?.[4]?.MLNumericScore ?? null,
      ],
    },
  ];

  const seriesoptions = {
    chart: {
      type: "bar",
      height: 200,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        barHeight: "50%",
        distributed: true,
      },
    },
    colors: ["#4FABFF"],
    dataLabels: {
      enabled: false,

      dropShadow: {
        enabled: true,
      },
    },

    xaxis: {
      categories: [
        "Critical Thinking",
        "Communication",
        "Team Work",
        "Growth Mindset",
        "Active Listening",
      ],
    },
    yaxis: {
      show: true,
      min: 0,
      max: 5,
      tickAmount: 5,
      stepSize: 1,
    },
    legend: {
      show: false,
    },
  };
  const radarData = {
    labels: [
      "Critical Thinking",
      "Growth Mindset",
      "Communication",
      "Teamwork",
      "Active Listening",
    ],
    datasets: [
      {
        data: [
          interviews?.[0]?.chunk?.[0]?.BiLSTMScore ?? interviews?.[0]?.chunk?.[0]?.MLNumericScore ?? 0,
          interviews?.[0]?.chunk?.[3]?.BiLSTMScore ?? interviews?.[0]?.chunk?.[3]?.MLNumericScore ?? 0,
          interviews?.[0]?.chunk?.[1]?.BiLSTMScore ?? interviews?.[0]?.chunk?.[1]?.MLNumericScore ?? 0,
          interviews?.[0]?.chunk?.[2]?.BiLSTMScore ?? interviews?.[0]?.chunk?.[2]?.MLNumericScore ?? 0,
          interviews?.[0]?.chunk?.[4]?.BiLSTMScore ?? interviews?.[0]?.chunk?.[4]?.MLNumericScore ?? 0,
        ],
        backgroundColor: "rgba(99, 102, 241, 0.25)",
        borderColor: "rgba(99, 102, 241, 0.85)",
        borderWidth: 2,
        pointBackgroundColor: "rgba(99, 102, 241, 1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(99, 102, 241, 1)",
        pointRadius: 4,
      },
    ],
  };

  const radarChartOptions = {
    scales: {
      r: {
        angleLines: { display: true, color: "#e2e8f0" },
        grid: { circular: true, color: "#e2e8f0" },
        pointLabels: {
          font: { size: 13, weight: "600" },
          color: "#1e293b",
        },
        ticks: {
          backdropColor: "transparent",
          stepSize: 1,
          max: 5,
          min: 0,
          color: "#94a3b8",
          font: { size: 11 },
        },
        min: 0,
        max: 5,
      },
    },
    plugins: { legend: { display: false }, tooltip: { enabled: false } },
    maintainAspectRatio: true,
  };

  function Progressbar({ progress }) {
    return (
      <div className="flex flex-col items-center w-full">
        <div
          className="relative w-full h-[2rem]  rounded-full overflow-hidden"
          style={{
            // border: "2px solid rgba(210, 212, 218, 1)",
            backgroundColor: "#E7F4FF",
          }}
        >
          <div
            style={{ width: `${progress}%` }}
            className="h-full bg-[#006FD6] transition-width duration-500 rounded-full"
          ></div>
        </div>
      </div>
    );
  }
  const patchStatus = (id, status) => {
    axios
      .patch(`${server_API}/v2/applicant/update`, {
        companyid: companyID,
        uuid: id,
        status: status,
      })
      .then((res) => {
        window.location.reload();
        console.log(res);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getVideoUrl = (path, ques) => {
    setActiveQuestion(ques);
    axios
      .get(`${server_API}/v2/interview/geturl/${companyID}/${path}`)
      .then((response) => {
        console.log(response);
        setUrl(response.data.url);
        setOpenPlayer(true);
      })

      .catch((err) => {
        console.log(err);
      });
  };
  const sendEmail = () => {
    setSelectdRows([uuid]);
    console.log(selectedRows);
    axios
      .post(`${server_API}/v2/applicant/shortlisted`, {
        JobID: jobid,
        CompanyID: companyID,
        ApplicantID: selectedRows,
        UserID: applicantId,
      })
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // const SwipeFeedback = () => ... (removed internal version)

  const Swipe = () => {
    console.log("interviews", interviews);
    return (
      <div>
        {interviews.length > 0 ? (
          <div className="">
            <Swiper
              modules={[Navigation, A11y]}
              spaceBetween={60}
              slidesPerView={4}
              navigation
            >
              {interviews[0].chunk.map((c, i) => (
                <SwiperSlide key={i}>
                  <div
                    onClick={() => {
                      getVideoUrl(c.Path, c.QuestionText);
                      setActiveIndex(i);
                    }}
                    className="border-2 border-slate-300 cursor-pointer flex flex-col items-start p-4 rounded-lg relative h-full"
                  >
                    <div className="relative flex-shrink-0">
                      {" "}
                      {/* Make this div shrink to fit content */}
                      <img
                        src={frame}
                        className="rounded-lg h-30"
                        alt="frame"
                      />
                      <img
                        src={frame1}
                        className="rounded-lg h-10 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 hover:scale-[130%] transition-all"
                        alt="frame1"
                      />
                    </div>

                    <p className="my-3 leading-tight text-sm font-normal text-left flex-grow">
                      {" "}
                      {/* Make this paragraph grow to fill remaining space */}Q
                      {i + 1}. {c.QuestionText}
                    </p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        ) : (
          <div className="px-4 font-normal ">
            The candidate has not given any interviews yet.
          </div>
        )}
      </div>
    );
  };

  const CandidateSummary = () => {
    return (
      <div className="flex-1 overflow-auto summarypage p-4 m-4 rounded-xl  bg-white">
        <div className="flex items-center ">
          <div>
            <div className="flex gap-4 mb-2 ">
              <h2 className="text-2xl font-semibold flex items-center">
                {applicant.name}
              </h2>
              <span className="text-lg font-semibold flex items-center">
                {" "}
                | &nbsp;{jobDetails.profilename}
              </span>
              {/* <span className="inline-block bg-light-green border border-[#40B2B7] text-[#40B2B7] px-2 py-1 text-sm font-medium rounded-md">
                High Match
              </span> */}
            </div>
            <p className="text-base font-normal mb-2">
              <span className=" font-medium">Email: </span>
              <a className="text-blue-400" href="mailto:recipient@example.com">
                {applicant.email}
              </a>
              &nbsp; | &nbsp; <span className=" font-medium">Phone: </span>{" "}
              {getPhoneCode(companyCountryCode)}&nbsp;
              {applicant.phone} &nbsp; |&nbsp;{" "}
              <span className=" font-medium">Location: </span>
              {applicant.address}&nbsp;
            </p>
            <p className="text-base font-normal">
              <span className=" font-medium">Education: </span>
              {applicant.highestqualification}
              <span className=" font-medium">Total Experience: </span>
              {applicant.totalexperience}
            </p>
          </div>
        </div>

        <div className=" w-full mt-6 ">
          <h2 className="font-semibold mt-1 relative mb-2 text-xl ">Skills</h2>

          <div className="flex flex-wrap gap-2 ">
            {skillArray?.map((skills, index) => (
              <span className="bg-[#f0f4fc] border-2 border-slate-300 font-semibold px-3 py-1 rounded-lg">
                {skills}
              </span>
            ))}
          </div>
        </div>

        {/* before:block before:bg-blue-500 before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-2/4 before:mr-4 before:transform before:-translate-y-1/2 */}

        <div className=" w-full mt-6 flex gap-4  ">
          <div className="w-1/2">
            <h2 className="font-semibold relative mb-2 mt-1 text-xl  ">
              Annual Salary
            </h2>
            <div className="flex gap-4">
              <h3 className="text-slate-600 text-md font-medium  pl-4 rounded-lg p-2 mb-2 border-2 border-slate-300 flex justify-between  relative  mt-1   before:block before:bg-blue-500 before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-1/3 before:mr-4 before:transform before:-translate-y-1/2">
                Current Salary:
                <span className=" font-semibold text-black ml-2">
                  {getCurrencySymbol(companyCountryCode)}
                  {formatSalary(applicant.currentsalary, companyCountryCode)}
                </span>
              </h3>
              <h3 className="text-slate-600  text-md p-2  pl-4 mb-2 font-medium rounded-lg border-2 flex justify-between  relative  mt-1   before:block before:bg-blue-500 before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-1/3 before:mr-4 before:transform before:-translate-y-1/2">
                Expected Salary:
                <span className=" font-semibold text-black ml-2">
                  {getCurrencySymbol(companyCountryCode)}
                  {formatSalary(applicant.expectedsalary, companyCountryCode)}
                </span>{" "}
              </h3>
            </div>
          </div>
          <div className="w-1/2">
            <div className=" w-full  ">
              <h2 className="font-semibold relative mb-2 mt-1 text-xl  ">
                Time to Join
              </h2>

              <h3 className="text-slate-600 font-medium text-md   pl-4 rounded-lg p-2 mb-2 border-2 border-slate-300 flex justify-between  relative  mt-1   before:block before:bg-blue-500 before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-1/3 before:mr-4 before:transform before:-translate-y-1/2">
                Approximate time to join:
                <span className=" font-semibold text-black ml-2">2 Weeks</span>
              </h3>
            </div>
          </div>
        </div>

        <div className=" w-full mt-6  ">
          <h2 className="font-semibold relative mb-2 mt-1 text-xl  ">
            Candidate Evaluation
          </h2>

          <div className="flex items-center bg-white border-2 border-slate-300   rounded-xl mt-6">
            <div className=" w-full ">
              <h2 className="font-semibold w-full pl-4 bg-[#f0f4fc] rounded-t-xl relative  text-xl p-2 before:block before:bg-blue-500 before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-1/3 before:mr-4 before:transform before:-translate-y-1/2">
                AI Interview
              </h2>
              <hr className="border-gray-200 " />

              <div className="h-fit m-4">
                <div className="w-full flex xl:flex-row flex-col gap-4">
                  <div className="xl:w-[60%] w-full flex flex-col gap-4">
                    <div className="flex gap-4 lg:flex-row flex-col  ">
                      <div className="border-2 lg:w-1/2 w-full border-slate-300 rounded-xl">
                        <h2 className="p-4 text-base font-semibold">
                          Northstarz.Ai Rank: {rank}
                        </h2>
                        <hr className="border-[#E9EBFA] border-b-2  " />
                        <div className="p-5">
                          {" "}
                          <Progressbar
                            progress={
                              ((jobDetails.totalapplication - rank + 1) /
                                jobDetails.totalapplication) *
                              100
                            }
                          />
                        </div>
                      </div>
                      <div className="border-2 lg:w-1/2 w-full border-slate-300 rounded-xl">
                        <h2 className="p-4 text-base font-semibold">
                          Aggregate Score: {applicant.aggregate}
                        </h2>
                        <hr className="border-[#E9EBFA] border-b-2  " />
                        <div className="p-5">
                          {" "}
                          <Progressbar progress={applicant?.aggregate} />
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex sm:flex-wrap sm:flex-row flex-col gap-4 justify-between lg:flex-nowrap">
                      <div className="border-2 flex-1 lg:w-1/3 sm:w-1/2 w-full border-slate-300 rounded-xl overflow-hidden flex flex-col justify-center items-center">
                        <h2 className="p-4 text-base font-semibold">
                          Resume Score: {applicant?.resumescore}
                        </h2>
                        <hr className="border-[#E9EBFA] border-b-2 w-full" />
                        <div className="w-[11.2rem] h-[6rem] relative overflow-hidden m-5 flex justify-center py-5 items-center">
                          <ReactApexChart
                            className="absolute -bottom-16"
                            options={options}
                            series={[applicant?.resumescore]}
                            type="radialBar"
                            height={280}
                          />
                        </div>
                      </div>
                      <div className="border-2 flex-1 lg:w-1/3 sm:w-1/2 w-full border-slate-300 rounded-xl overflow-hidden flex flex-col justify-center items-center">
                        <h2 className="p-4 text-base font-semibold">
                          Technical Score: {applicant?.technicalscore}
                        </h2>
                        <hr className="border-[#E9EBFA] border-b-2 w-full" />
                        <div className="w-[11.2rem] h-[6rem] relative overflow-hidden m-5 flex justify-center items-center">
                          <ReactApexChart
                            className="absolute -bottom-16"
                            options={options}
                            series={[applicant?.technicalscore]}
                            type="radialBar"
                            height={280}
                          />
                        </div>
                      </div>
                      <div className="border-2  lg:w-1/3 sm:w-full w-full border-slate-300 rounded-xl flex flex-col overflow-hidden justify-center items-center">
                        <h2 className="p-4 text-base font-semibold">
                          Voice Score: {applicant?.voiceanalysisscore}
                        </h2>
                        <hr className="border-[#E9EBFA] border-b-2 w-full" />
                        <div className="w-[11.2rem] h-[6rem] relative overflow-hidden m-5 flex justify-center items-center">
                          <ReactApexChart
                            className="absolute -bottom-16"
                            options={options}
                            series={[applicant?.voiceanalysisscore]}
                            type="radialBar"
                            height={280}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="xl:w-[40%] w-full">
                    <div className="border-2  border-slate-300 rounded-xl">
                      <h2 className="p-4 text-base font-semibold">
                        Soft Skill Score: {applicant.aiscore}
                      </h2>
                      <hr className="border-[#E9EBFA] border-b-2  " />
                      <div className="absolute">
                        <ReactApexChart
                          options={seriesoptions}
                          series={series}
                          type="bar"
                          height={230}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  if (Object.keys(applicant).length > 0)
    return (
      <>
        <div className="p-8 bg-[#f0f4fc]  min-h-screen    ">
          {openSummary && (
            <div className="fixed py-12    bg-black bg-opacity-60  p-4 h-screen w-screen text-white flex items-center justify-center  top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-20">
              <div className="w-[80%] h-full flex flex-col bg-[#f0f4fc] rounded-xl border-2 border-slate-500 text-black">
                {/* Top div */}
                <div className="flex p-4 bg-white items-center justify-between rounded-t-xl">
                  <h1 className="text-2xl font-semibold">Candidate Overview</h1>
                  <RxCross2
                    className="self-start text-3xl cursor-pointer z-50"
                    onClick={() => {
                      setOpenSummary(false);
                    }}
                  ></RxCross2>
                </div>

                {/* Middle div with scrolling */}
                <CandidateSummary />

                {/* Bottom div */}
                <div className="flex p-4 bg-white items-center justify-end rounded-b-xl">
                  <button className="bg-[#148EFF] whitespace-nowrap text-white py-2 px-4 w-fit rounded-lg">
                    Download Now
                  </button>
                </div>
              </div>
            </div>
          )}
          {openPlayer && (
            <div className="fixed  bg-black bg-opacity-60 backdrop-blur-lg p-4 h-screen w-screen text-white flex items-center justify-center  top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-20">
              <RxCross2
                className="self-start text-3xl cursor-pointer z-50"
                onClick={() => {
                  setOpenPlayer(false);
                }}
              ></RxCross2>
              <div className="w-full h-[85%] px-4">
                <p className="text-lg my-2 text-center">
                  Q{activeIndex + 1}. {activeQuestion}
                </p>
                <div className="flex w-full h-full justify-between items-center">
                  <button
                    onClick={() => {
                      setActiveIndex((prev) => prev - 1);
                    }}
                    disabled={activeIndex == 0}
                    className={
                      !(activeIndex == 0)
                        ? "bg-cyan-600 text-2xl text-white p-4 rounded-full"
                        : "bg-cyan-600 text-2xl text-white p-4 rounded-full opacity-50"
                    }
                  >
                    <MdOutlineNavigateNext className="rotate-180"></MdOutlineNavigateNext>
                  </button>
                  <video
                    src={url}
                    controls
                    autoplay
                    className="rounded-lg mx-auto w-[80%] h-[80%]"
                  ></video>
                  <button
                    className={
                      !(interviews[0].chunk.length == activeIndex + 1)
                        ? "bg-cyan-600 text-2xl text-white p-4 rounded-full"
                        : "bg-cyan-600 text-2xl text-white p-4 rounded-full opacity-50"
                    }
                    disabled={interviews[0].chunk.length == activeIndex + 1}
                    onClick={() => {
                      setActiveIndex((prev) => prev + 1);
                    }}
                  >
                    <MdOutlineNavigateNext></MdOutlineNavigateNext>
                  </button>
                </div>
              </div>
            </div>
          )}
          <div className="flex  justify-between items-center">
            <h1 className="text-3xl font-semibold">Candidate Overview</h1>
            <div className="flex justify-center items-center gap-4 ">
              <div className="relative ">
                <button
                  className={
                    !open
                      ? "py-2 h-full  bg-[#40B2B7] text-white px-3 rounded-lg"
                      : "py-2 h-full  bg-[#40B2B7] text-white px-3 rounded-t-lg"
                  }
                  onClick={() => {
                    setOpen(!open);
                  }}
                >
                  <div className="flex items-center justify-between px-2">
                    {applicant.status}

                    <img
                      src={arrow}
                      className={
                        !open ? "-rotate-90 ml-4 h-2" : "-rotate-270 ml-4 h-2"
                      }
                    ></img>
                  </div>
                </button>

                {open && (
                  <div className="flex flex-col bg-[#5AA7EF] absolute w-full text-white rounded-b-lg">
                    {applicant.status === "Pending" && (
                      <>
                        <button
                          onClick={() => {
                            patchStatus(applicant.uuid, "Rejected");
                          }}
                        >
                          <div className="flex items-center space-x-4 py-3 px-3">
                            <p>Rejected</p>
                          </div>
                        </button>
                      </>
                    )}

                    {applicant.status === "Interviewed" && (
                      <>
                        <button
                          onClick={() => {
                            patchStatus(applicant.uuid, "Shortlisted");
                          }}
                        >
                          <div className="flex items-center space-x-4 py-3 px-3">
                            <p>Shortlist</p>
                          </div>
                        </button>
                        <button
                          onClick={() => {
                            patchStatus(applicant.uuid, "Rejected");
                          }}
                        >
                          <div className="flex items-center space-x-4 py-3 px-3">
                            <p>Rejected</p>
                          </div>
                        </button>
                      </>
                    )}

                    {applicant.status === "Shortlisted" && (
                      <>
                        <button
                          onClick={() => {
                            patchStatus(applicant.uuid, "Rejected");
                          }}
                        >
                          <div className="flex items-center space-x-4 py-3 px-3">
                            <p>Reject</p>
                          </div>
                        </button>
                        <button
                          onClick={() => {
                            patchStatus(applicant.uuid, "Interviewed");
                          }}
                        >
                          <div className="flex items-center space-x-4 py-3 px-3">
                            <p>Deselect</p>
                          </div>
                        </button>
                      </>
                    )}

                    {applicant.status === "Rejected" && (
                      <>
                        <button
                          onClick={() => {
                            patchStatus(applicant.uuid, "Shortlisted");
                          }}
                        >
                          <div className="flex items-center space-x-4 py-3 px-3">
                            <p>Shortlist</p>
                          </div>
                        </button>

                        {}
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="flex items-center justify-between bg-white shadow-md  p-4 rounded-2xl mt-6">
            <div className="flex items-center w-full  ">
              {/* <img
              src="https://placehold.co/100"
              alt="Avatar"
              className="rounded-2xl mr-4 border-2 border-slate-300"
            /> */}
              <div className="w-[80%]">
                <div className="flex gap-4 mb-2  ">
                  <h2 className="text-2xl font-semibold flex items-center">
                    {applicant.name}
                  </h2>
                  <span className="text-lg font-semibold flex items-center">
                    {" "}
                    | &nbsp;{jobDetails.profilename}
                  </span>
                  {/* <span className="inline-block bg-light-green border border-[#40B2B7] text-[#40B2B7] px-2 py-1 text-sm font-medium rounded-md">
                  High Match
                </span> */}
                </div>

                <p className="text-base  font-normal mb-2">
                  <span className=" font-medium">Email: </span>
                  <a
                    className="text-blue-400"
                    href="mailto:recipient@example.com"
                  >
                    {applicant.email}
                  </a>
                  &nbsp; | &nbsp; <span className=" font-medium">Phone: </span>{" "}
                  {getPhoneCode(companyCountryCode)}&nbsp;
                  {applicant.phone} &nbsp;
                  {applicant?.address?.length > 10 && (
                    <span>
                      <span className=" font-medium">Location: </span>
                      {applicant?.address?.split(",")[3]}, India
                    </span>
                  )}
                </p>
                <p className=" text-  font-normal">
                  <p className="mb-2 font-medium">
                    Education: {applicant.qualification}
                  </p>
                  <span className=" font-medium">Total Experience: </span>
                  {applicant.totalexperience}
                </p>
              </div>
            </div>
            <button
              className="bg-[#148EFF]  whitespace-nowrap text-white py-2 px-6 w-fit   rounded-lg  "
              onClick={() => {
                showResume();
              }}
            >
              Resume
            </button>
          </div>

          <div className="flex items-center bg-white shadow-md  rounded-2xl mt-6">
            <div className=" w-full ">
              <h2 className="font-semibold mt-1 relative mb-2 text-xl p-4 before:block before:bg-blue-500 before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-2/4 before:mr-4 before:transform before:-translate-y-1/2">
                Skills
              </h2>
              <hr className="border-gray-200 " />
              <div className="flex flex-wrap gap-2 p-4">
                {skillArray.map((skills, index) => (
                  <span className="bg-[#f0f4fc] border-2 border-slate-300 font-semibold px-3 py-1 rounded-lg">
                    {skills}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4 ">
            <div className="flex items-center bg-white shadow-md rounded-2xl mt-6">
              <div className=" w-full ">
                <div className="flex items-center space-x-2 ">
                  <h2 className="font-semibold relative mb-2 mt-1 text-xl p-4 before:block before:bg-blue-500 before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-2/4 before:mr-4 before:transform before:-translate-y-1/2">
                    Annual Salary
                  </h2>
                  <div className="text-sm font-semibold">
                    {parseInt(
                      applicant?.expectedsalary
                        ?.split(" ")[1]
                        ?.replaceAll(",", ""),
                    ) < minSalary && (
                      <div className="bg-[#E9EBFA] border-[#8F94A1] text-[#8F94A1] py-1 px-2 rounded-lg">
                        <p>Below Range</p>
                      </div>
                    )}
                    {parseInt(
                      applicant?.expectedsalary
                        ?.split(" ")[1]
                        ?.replaceAll(",", ""),
                    ) >= minSalary &&
                      parseInt(
                        applicant?.expectedsalary
                          ?.split(" ")[1]
                          ?.replaceAll(",", ""),
                      ) <= maxSalary && (
                        <div className="bg-[#E9EBFA] border-[#40B2B7] border-2 text-[#40B2B7] py-1 px-2 rounded-lg">
                          <p>Within Range</p>
                        </div>
                      )}
                    {parseInt(
                      applicant?.expectedsalary
                        ?.split(" ")[1]
                        ?.replaceAll(",", ""),
                    ) > maxSalary && (
                      <div className="bg-[#E9EBFA] border-[#E95060] border-2 text-[#E95060] py-1 px-2 rounded-lg">
                        <p>Above Range</p>
                      </div>
                    )}
                  </div>
                </div>
                <hr className="border-gray-200 " />
                <div className="flex gap-8 flex-wrap  p-4 font-medium">
                  <h3 className="text-slate-600">
                    Current Salary:{" "}
                    <span className=" font-semibold text-black">
                      {getCurrencySymbol(companyCountryCode)} {formatSalary(applicant.currentsalary, companyCountryCode)}
                    </span>{" "}
                  </h3>
                  <h3 className="text-slate-600">
                    Expected Salary:{" "}
                    <span className=" font-semibold text-black">
                      {getCurrencySymbol(companyCountryCode)} {formatSalary(applicant.expectedsalary, companyCountryCode)}
                    </span>{" "}
                  </h3>
                </div>
              </div>
            </div>
            <div className="flex items-center bg-white shadow-md  rounded-2xl mt-6">
              <div className=" w-full ">
                <h2 className="font-semibold relative mb-2 mt-1 text-xl p-4 before:block before:bg-blue-500 before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-2/4 before:mr-4 before:transform before:-translate-y-1/2">
                  Time to Join
                </h2>
                <hr className="border-gray-200 " />
                <div className="flex gap-8 flex-wrap  p-4 font-medium">
                  <h3 className="text-slate-600">
                    Approximate time to join:
                    <span className=" font-semibold text-black">
                      {" "}
                      {applicant.joiningtime} days
                    </span>
                  </h3>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white shadow-md rounded-2xl mt-6">
            {/* Header */}
            <div className="flex w-full justify-between items-center font-semibold relative text-xl p-4 before:block before:bg-blue-500 before:w-1 before:content-[''] before:absolute before:left-0 before:top-1/2 before:h-1/2 before:transform before:-translate-y-1/2">
              <p>AI Interview</p>
              <button
                className="bg-transparent border-none text-2xl"
                onClick={toggleAi}
              >
                {isAIVisible ? (
                  <IoIosArrowUp className="text-gray-800" />
                ) : (
                  <IoIosArrowDown className="text-gray-800" />
                )}
              </button>
            </div>

            {isAIVisible && (
              <div className="px-6 pb-6">
                {/* Top 3 scores row */}
                <div className="grid grid-cols-3 gap-8 mb-5">
                  <div>
                    <p className="text-sm font-semibold text-gray-700 mb-2">
                      Aggregate AI Score :{" "}
                      <span className="text-blue-500">{applicant.aggregate}</span>
                    </p>
                    <div className="w-full h-1.5 rounded-full bg-[#E7F4FF]">
                      <div
                        className="h-full bg-[#006FD6] rounded-full transition-all duration-500"
                        style={{ width: `${applicant.aggregate}%` }}
                      />
                    </div>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-gray-700 mb-2">
                      Resume Score :{" "}
                      <span className="text-blue-500">
                        {applicant?.resumescore === -1
                          ? "N/A"
                          : applicant?.resumescore}
                      </span>
                    </p>
                    <div className="w-full h-1.5 rounded-full bg-[#E7F4FF]">
                      <div
                        className="h-full bg-[#006FD6] rounded-full transition-all duration-500"
                        style={{
                          width: `${applicant?.resumescore === -1 ? 0 : applicant?.resumescore}%`,
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-gray-700 mb-2">
                      Voice Score :{" "}
                      <span className="text-blue-500">
                        {applicant?.voiceanalysisscore}
                      </span>
                    </p>
                    <div className="w-full h-1.5 rounded-full bg-[#E7F4FF]">
                      <div
                        className="h-full bg-[#006FD6] rounded-full transition-all duration-500"
                        style={{ width: `${applicant?.voiceanalysisscore}%` }}
                      />
                    </div>
                  </div>
                </div>

                {/* Two expandable score cards — always compact, no content inside */}
                <div className="grid grid-cols-2 gap-4">
                  {/* Technical Score card */}
                  <div
                    className={`border rounded-xl cursor-pointer transition-all duration-200 ${
                      expandedSection === "technical"
                        ? "border-blue-400 bg-white shadow-sm"
                        : "border-slate-200 bg-white"
                    }`}
                    onClick={() =>
                      setExpandedSection((prev) =>
                        prev === "technical" ? null : "technical"
                      )
                    }
                  >
                    <div className="flex justify-between items-center px-4 pt-4 pb-2">
                      <p
                        className={`font-semibold text-sm ${
                          expandedSection === "technical"
                            ? "text-gray-900"
                            : expandedSection === "employability"
                            ? "text-gray-400"
                            : "text-gray-700"
                        }`}
                      >
                        Technical Score :{" "}
                        <span className="text-blue-500">
                          {applicant?.technicalscore}
                        </span>
                      </p>
                      {expandedSection === "technical" ? (
                        <IoIosArrowUp className="text-gray-500 flex-shrink-0" />
                      ) : (
                        <IoIosArrowDown className="text-gray-500 flex-shrink-0" />
                      )}
                    </div>
                    <div className="px-4 pb-4">
                      <div className="w-full h-1.5 rounded-full bg-[#E7F4FF]">
                        <div
                          className="h-full bg-[#006FD6] rounded-full transition-all duration-500"
                          style={{ width: `${applicant?.technicalscore}%` }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Employability Score card */}
                  <div
                    className={`border rounded-xl cursor-pointer transition-all duration-200 ${
                      expandedSection === "employability"
                        ? "border-blue-400 bg-white shadow-sm"
                        : "border-slate-200 bg-white"
                    }`}
                    onClick={() =>
                      setExpandedSection((prev) =>
                        prev === "employability" ? null : "employability"
                      )
                    }
                  >
                    <div className="flex justify-between items-center px-4 pt-4 pb-2">
                      <p
                        className={`font-semibold text-sm ${
                          expandedSection === "employability"
                            ? "text-gray-900"
                            : expandedSection === "technical"
                            ? "text-gray-400"
                            : "text-gray-700"
                        }`}
                      >
                        Employability Score :{" "}
                        <span className="text-blue-500">{applicant?.aiscore}</span>
                      </p>
                      {expandedSection === "employability" ? (
                        <IoIosArrowUp className="text-gray-500 flex-shrink-0" />
                      ) : (
                        <IoIosArrowDown className="text-gray-500 flex-shrink-0" />
                      )}
                    </div>
                    <div className="px-4 pb-4">
                      <div className="w-full h-1.5 rounded-full bg-[#E7F4FF]">
                        <div
                          className="h-full bg-[#006FD6] rounded-full transition-all duration-500"
                          style={{ width: `${applicant?.aiscore}%` }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Expanded content — below both cards, inside main AI Interview card */}
                {expandedSection === "technical" && (
                  <div className="mt-5 pt-4 border-t border-slate-100">
                    <p className="text-sm text-gray-700">
                      <span className="font-bold">Summary:</span> Summary will
                      be available soon.
                    </p>
                  </div>
                )}

                {expandedSection === "employability" && (
                  <div className="mt-5 pt-2 border-t border-slate-100">
                    <div className="flex gap-8 items-center">
                      <div className="flex-1">
                        <Radar
                          data={radarData}
                          options={radarChartOptions}
                        />
                      </div>
                      <div className="flex-1">
                        <p className="text-sm text-gray-700">
                          <span className="font-bold">Summary:</span> Summary
                          will be available soon.
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* <div className="flex items-center bg-white shadow-md  rounded-2xl mt-6">
          <div className=" w-full ">
            <h2 className=" flex justify-between font-semibold relative mb-2 mt-1 text-xl p-4 before:block before:bg-blue-500 before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-2/4 before:mr-4 before:transform before:-translate-y-1/2">
              AI Interview
              <button
                className="bg-transparent border-none text-white text-2xl mr-4"
                onClick={toggleAi}
              >
                {isAIVisible ? (
                  <IoIosArrowUp className="text-gray-800" />
                ) : (
                  <IoIosArrowDown className="text-gray-800" />
                )}
              </button>
            </h2>
            <hr className="border-gray-200 " />
            <div
              className={`${
                isAIVisible ? "h-fit mb-4 " : "hidden"
              } flex gap-4  relative flex-wrap  p-4 font-medium`} //do not use hidden property to hide the div, instead use conditional rendering @sanjeev
            >
              <div className="w-full items-stretch flex xl:flex-row flex-col gap-4">
                <div className="xl:w-[60%] w-full h-full items-stretch flex flex-col gap-4">
                  <div className="flex gap-4 lg:flex-row flex-col  ">
                    <div className="border-2 lg:w-1/2 w-full border-slate-300 rounded-xl">
                      <h2 className="p-4 text-lg font-semibold">
                        Northstarz.Ai Rank: {rank}
                      </h2>
                      <hr className="border-[#E9EBFA] border-b-2  " />
                      <div className="p-5">
                        {" "}
                        <Progressbar progress={(((jobDetails.totalapplication-rank) + 1)/jobDetails.totalapplication)*100} />
                        
                      </div>
                    </div>
                    <div className="border-2 lg:w-1/2 w-full border-slate-300 rounded-xl">
                      <h2 className="p-4 text-lg font-semibold">
                        Aggregate Score: {applicant.aggregate}
                      </h2>
                      <hr className="border-[#E9EBFA] border-b-2  " />
                      <div className="p-5">
                        {" "}
                        <Progressbar progress={applicant.aggregate} />
                      </div>
                    </div>
                  </div>
                  <div className="w-full flex sm:flex-wrap sm:flex-row flex-col gap-4 justify-between lg:flex-nowrap">
  <div className="border-2 flex-1 lg:w-full sm:w-1/2 w-full border-slate-300 rounded-xl overflow-hidden flex flex-col justify-center items-center">
    <h2 className="p-4 text-lg font-semibold">Resume Score: {applicant?.resumescore == -1?"Not available":applicant?.resumescore}</h2>
    <hr className="border-[#E9EBFA] border-b-2 w-full" />
    <div className=" relative overflow-hidden m-5 flex justify-center items-center">
      <ReactApexChart
        className=""
        options={options}
        
        series={[applicant?.resumescore]}
        type="radialBar"
        height={300}
      />
    </div>
  </div>
  {
    jobDetails?.questionid?.length>0 &&
    <div className="border-2 flex-1 lg:w-full sm:w-1/2 w-full border-slate-300 rounded-xl overflow-hidden flex flex-col justify-center items-center">
      <h2 className="p-4 text-lg font-semibold">Technical Score: {applicant?.technicalscore}</h2>
      <hr className="border-[#E9EBFA] border-b-2 w-full" />
      <div className=" relative overflow-hidden m-5 flex justify-center items-center">
        <ReactApexChart
          className=""
          options={options}
          series={[applicant?.technicalscore]}
          type="radialBar"
          height={300}
        />
      </div>
    </div>
  }
  <div className="border-2  lg:w-full flex-1 sm:w-full w-full border-slate-300 rounded-xl flex flex-col overflow-hidden justify-center items-center">
    <h2 className="p-4 text-lg font-semibold">Voice Score: {applicant?.voiceanalysisscore}</h2>
    <hr className="border-[#E9EBFA] border-b-2 w-full" />
    <div className=" relative overflow-hidden m-5 -pb-5 flex justify-center items-center">
      <ReactApexChart
        className=""
        options={options}
        series={[applicant?.voiceanalysisscore]}
        type="radialBar"
        height={300}
      />
    </div>
  </div>
</div>

                </div>
                <div className="xl:w-[40%] h-full items-stretch w-full">
                  <div className="border-2 h-full items-stretch  border-slate-300 rounded-xl">
                    <h2 className="p-4 text-lg font-semibold">
                      Soft Skill Score: {applicant?.aiscore}
                    </h2>
                    <hr className="border-[#E9EBFA] border-b-2  " />
                    <div className="p-5">
                     
                      <ReactApexChart
                        options={seriesoptions}
                        series={series}
                        type="bar"
                        height={253}
                      />
                    </div>
                  </div>
                </div>
              </div>

              
            </div>
          </div>
        </div> */}

          <div className="flex items-center bg-white shadow-md  rounded-2xl mt-6">
            <div className=" w-full  ">
              <div className="flex justify-between items-center w-full ">
                <h2 className=" flex justify-between mb-2  font-semibold relative w-full  mt-1 text-xl p-4 before:block before:bg-blue-500 before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-2/4 before:mr-4 before:transform before:-translate-y-1/2">
                  Interview Feedbacks
                  <button
                    className="bg-transparent border-none text-white text-2xl mr-4"
                    onClick={toggleFeedback}
                  >
                    {isFeedbackVisible ? (
                      <IoIosArrowUp className="text-gray-800" />
                    ) : (
                      <IoIosArrowDown className="text-gray-800" />
                    )}
                  </button>
                </h2>
              </div>
              <hr className="border-gray-200 " />

              <div
                className={`max-w-[1300px]  m-auto overflow-hidden bg-white transition-all   ${
                  isFeedbackVisible ? "max-h-[900px] mb-4 mt-4" : "max-h-0 "
                }`}
              >
                <SwipeFeedback
                  roundsinfo={applicant.roundsinfo}
                  isFromACFL={isFromACFL}
                />
              </div>
            </div>
          </div>

          <div className="flex items-center bg-white shadow-md  rounded-2xl mt-6">
            <div className=" w-full  ">
              <div className="flex justify-between items-center w-full ">
                <h2 className=" flex justify-between mb-2  font-semibold relative w-full  mt-1 text-xl p-4 before:block before:bg-blue-500 before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-2/4 before:mr-4 before:transform before:-translate-y-1/2">
                  Recorded Interviews
                  <button
                    className="bg-transparent border-none text-white text-2xl mr-4"
                    onClick={toggleDocument}
                  >
                    {isDocumentVisible ? (
                      <IoIosArrowUp className="text-gray-800" />
                    ) : (
                      <IoIosArrowDown className="text-gray-800" />
                    )}
                  </button>
                </h2>
              </div>
              <hr className="border-gray-200 " />

              <div
                className={`max-w-[1300px]  m-auto overflow-hidden bg-white transition-max-h   ${
                  isDocumentVisible ? "max-h-[900px] mb-4 mt-4" : "max-h-0 "
                }`}
              >
                <Swipe />
              </div>
            </div>
          </div>

          <div className="flex items-center bg-white shadow-md  rounded-2xl mt-6">
            <div className=" w-full  ">
              <div className="flex justify-between items-center w-full ">
                <h2 className=" flex justify-between mb-2  font-semibold relative w-full  mt-1 text-xl p-4 before:block before:bg-blue-500 before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-2/4 before:mr-4 before:transform before:-translate-y-1/2">
                  Documents
                  <button
                    className="bg-transparent border-none text-white text-2xl mr-4"
                    onClick={() => {
                      setViewDocuments(!viewDocuments);
                    }}
                  >
                    {viewDocuments ? (
                      <IoIosArrowUp className="text-gray-800" />
                    ) : (
                      <IoIosArrowDown className="text-gray-800" />
                    )}
                  </button>
                </h2>
              </div>
              <hr className="border-gray-200 " />

              <div
                className={`max-w-[1300px]  m-auto overflow-hidden bg-white transition-max-h  ${
                  viewDocuments ? "max-h-[900px] mb-4 mt-4" : "max-h-0 "
                }`}
              >
                {documents.length > 0 ? (
                  <div>
                    <div className="flex items-center justify-between ">
                      <TfiReload></TfiReload>
                      <button className="rounded-lg bg-[#148EFF] text-white py-2  px-3">
                        Add Document
                      </button>
                    </div>
                    <Table className="mt-5">
                      <Thead className="text-center text-sm sticky font-semibold bg-white">
                        <Tr>
                          <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                            Document
                          </Th>
                          <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                            Uploaded By
                          </Th>
                          <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                            Uploaded Date
                          </Th>
                          <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                            Current Status
                          </Th>
                          <Th className="border-y border-[#D2D4DA] py-5 px-2 text-center ">
                            Actions
                          </Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {documents.map((d) => {
                          return (
                            <Tr className="text-sm text-center">
                              <Td className="border-y py-5 w-1/5 border-[#D2D4DA] p-2 text-center  ">
                                {d.documentName}
                              </Td>
                              <Td className="border-y w-1/5 border-[#D2D4DA] p-2 text-center  ">
                                {d.uploadedBy}
                              </Td>

                              <Td className="border-y w-1/5 border-[#D2D4DA] p-2 text-center  ">
                                {d.uploadedDate}
                              </Td>
                              <Td className="border-y w-1/5 text-xs font-semibold border-[#D2D4DA] p-2 text-center  ">
                                {d.currentStatus == "Under Review" && (
                                  <div className="text-[#FE9933]">
                                    {d.currentStatus}
                                  </div>
                                )}
                                {d.currentStatus == "Rejected" && (
                                  <div className="text-[#E95060]">
                                    {d.currentStatus}
                                  </div>
                                )}
                                {d.currentStatus == "Verified" && (
                                  <div className="text-[#40B2B7]">
                                    {d.currentStatus}
                                  </div>
                                )}
                                {d.currentStatus == "Not Submitted" && (
                                  <div className="text-[#444D63]">
                                    {d.currentStatus}
                                  </div>
                                )}
                              </Td>
                              <Td className="border-y w-1/5">
                                <Select
                                  className="text-[14px] mx-auto"
                                  placeholder="Select Action"
                                  onChange={(selectedOption) => {
                                    setDocumentAction(selectedOption.value);
                                  }}
                                  options={
                                    d.currentStatus == "Under Review" ||
                                    d.currentStatus == "Verified"
                                      ? underReviewActions
                                      : rejectedActions
                                  }
                                ></Select>
                              </Td>
                            </Tr>
                          );
                        })}
                      </Tbody>
                    </Table>
                  </div>
                ) : (
                  <div className="text-center">
                    <img src={emptydocs} className="h-52 my-6 mx-auto "></img>
                    <p className="text-center font-semibold">
                      Documents have not been requested from the candidate yet.
                    </p>
                    <button className="my-6 bg-[#148EFF] rounded-lg text-white px-3 py-2">
                      Request Documents
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
          <Copyright />
        </div>
      </>
    );
};

export default TestAboutCandidate;
